import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import UAvatar from 'modules/user/UAvatar.component';
import {
  View,
  Row,
  Header,
  AltLink,
  BodyText,
  Text,
  Box,
  InlineLink,
} from 'modules/styled';
import ProfileStats from './profile.stats';

const SettingsImage = require('public/img/settings.svg');

class Profile extends Component {
  static propTypes = {
    actions: PropTypes.object,
    isOwner: PropTypes.bool,
    user: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object,
    bio: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  componentDidMount() {
    this.checkRouteForModal(true);
  }

  checkRouteForModal(firstRun) {
    const { user, actions, location, history } = this.props;
    if (location.search.match('modal=settings')) return;
    const settingsUrl = `/user/profile/${user.handle}/settings`;
    const profileUrl = `/user/profile/${user.handle}`;
    if (settingsUrl === location.pathname) {
      const searchString = `?redirect=${profileUrl}`;
      if (firstRun && location.search !== searchString) {
        history.push({ search: searchString });
      }
      actions.showModal('settings');
    }
  }

  render() {
    const { user, isOwner, actions, location, bio } = this.props;
    if (!user) {
      return <div className="profileContainer">User not found!</div>;
    }

    // TODO upload image button
    // let uploadImg;
    // if (this.props.auth.user && user._id === this.props.auth.user._id) {
    //   uploadImg = <button className={'uploadImg edit'}>Update Profile Image</button>;
    // }

    return (
      <Row sx={{ m: [2, 4], alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <UAvatar user={user} size={10} />
        <View sx={{ ml: 2, flex: 1, flexWrap: 'wrap' }}>
          <Row
            sx={{
              justifyContent: 'space-between',
              alignItems: 'baseline',
              flexWrap: 'wrap',
            }}
          >
            <Row sx={{ alignItems: 'baseline', flexShrink: 1, flexWrap: 'wrap' }}>
              <Header sx={{ mr: 2 }}>{user.name}</Header>
              <ProfileStats user={user} isOwner={isOwner} />
            </Row>
            {isOwner ? (
              <InlineLink
                onClick={() => {
                  actions.logoutAction(user);
                }}
                to="#"
              >
                Logout
              </InlineLink>
            ) : (
              <View />
            )}
          </Row>
          {bio ? <BodyText sx={{ mt: 2 }}>{bio}</BodyText> : null}
          {isOwner ? (
            <Row sx={{ alignItems: 'center', mt: 2 }}>
              <InlineLink
                c={'black'}
                hc={'grey'}
                to={`${location.pathname}/settings?redirect=${location.pathname}`}
              >
                <Text sx={{ color: 'inherit' }}>
                  <Text sx={{ display: 'inline-block', transform: [{ translateY: 2 }] }}>
                    <SettingsImage />
                  </Text>{' '}
                  <AltLink sx={{ color: 'inherit' }}>Settings</AltLink>
                </Text>
              </InlineLink>
              <Box sx={{ mr: 1 }} />
              <InlineLink
                to={'#'}
                c={'black'}
                hc={'grey'}
                onClick={(e) => {
                  e.preventDefault();
                  actions.showModal('linkMobile');
                }}
              >
                <Row sx={{ mr: 0.5, alignItems: 'center' }}></Row>
                <AltLink sx={{ color: 'inherit' }}>Connect Mobile Device</AltLink>
              </InlineLink>
            </Row>
          ) : null}
        </View>
      </Row>
    );
  }
}

export default withRouter(Profile);
